import { Spinner } from "@monbits/ui";
import type * as React from "react";

interface Props {
	isLoading: boolean;
	label?: string;
}

const SpinWithMask: React.FC<Props> = ({ isLoading, label = "Loading" }) => {
	return isLoading ? (
		<div
			role="status"
			aria-live="polite"
			className="absolute inset-0 z-10 flex items-center justify-center bg-foreground/5"
		>
			<Spinner aria-hidden="true" />
			<span className="sr-only">{label}</span>
		</div>
	) : null;
};

export default SpinWithMask;
